module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [_c('v-btn', {
    staticClass: "close-btn",
    attrs: {
      "absolute": "",
      "flat": "",
      "fab": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._v("x")]), _vm._v(" "), _c('v-flex', {
    staticClass: "last-order-modal",
    attrs: {
      "xs12": "",
      "text-xs-center": "",
      "py-3": ""
    }
  }, [_vm._v("\n    Order History #\n    (" + _vm._s(_vm.lastOrder.short ? _vm.lastOrder.short : _vm.lastOrder.id) + ")\n  ")]), _vm._v(" "), (_vm.err) ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "value": true,
      "type": "error"
    }
  }, [_vm._v(_vm._s(_vm.err))])], 1) : _vm._e(), _vm._v(" "), _c('v-data-table', {
    attrs: {
      "headers": _vm.headers,
      "items": _vm.trackingHistory
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', [_vm._v(_vm._s(props.index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.historyId))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.system))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatDate(props.item.createdOn)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.status))])]
      }
    }])
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-55b2683f","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/LastOrderModal.vue
// module id = 582
// module chunks = 5